<template>
  <div class="hotspot-detail menu-item-r">
    <el-steps class="steps-container" :space="200" :active="activeStep" finish-status="success" simple>
      <el-step :title="$t('Hotspot Upload Image')">
        <div slot="icon">1</div>
      </el-step>
      <el-step :title="$t('Set hotspot and combine products')">
        <div slot="icon">2</div>
      </el-step>
      <!-- <el-step :title="$t('Combine products')">
        <div slot="icon">3</div>
      </el-step> -->
    </el-steps>

    <div class="op-section" v-if="$route.params.step === 'step1'">
      <p>
        <strong>{{ $t('Hotspot Upload Image') }}</strong>
      </p>
      <div class="txt-notice">
        <div><i class="el-icon-warning"></i> {{ $t('Hotspot Upload Tips') }}</div>
      </div>
      <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="uploadFile()" :disabled="previewImageUrl.length !== 0">{{
        $t('Hotspot Upload Image')
      }}</el-button>
      <div class="scene-container">
        <DashUploadMore ref="scene-upload" :limit="1" :uploadBtn="false" size="large" fit="cover" :mediaUrl.sync="previewImageUrl" />
      </div>
    </div>

    <div class="op-section" v-if="$route.params.step === 'step2'">
      <p>
        <strong>{{ $t('Set hotspots and go to product detail.') }}</strong>
      </p>
      <div class="tip-block-example">
        <div class="icondiv">
          <div class="piiictips font-size-12">
            <template v-if="language === 'en'">
              <img src="@/assets/images/tipsEn.png" />
            </template>
            <template v-else>
              <img src="@/assets/images/tips.png" />
            </template>
          </div>

          <div class="flex flex-start">
            <img class="tips-image" src="@/assets/images/hotspotTips.png" />
          </div>
        </div>
        <div class="separate"></div>

        <p>
          <strong>{{ $t('Set hotspots') }}</strong>
        </p>
        <div class="txt-notice">
          <div><i class="el-icon-warning"></i> {{ $t('Hotspot tips2') }}</div>
        </div>

        <div class="hotspot-scene" ref="hotspot-scene">
          <img :src="hotspotDetail.url" class="scene-image" @click.self="addHotspot($event)" />

          <div
            class="hotspot drag-box"
            :id="_item.uuid"
            v-draggable="_item.draggableOption"
            v-for="(_item, _index) in hotspots"
            :style="{ top: `${_item.cdnY}px`, left: `${_item.cdnX}px` }"
            :key="_item.uuid"
          >
            <div class="shadow"></div>
            <div class="hotspot-index">{{ _index + 1 }}</div>
            <div class="close" @click="delHotspot(_item.uuid)"><i class="el-icon-close"></i></div>
          </div>
        </div>

        <!-- <div class="text-right button-wrap">
          <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="addHotspot()" :disabled="hotspots.length === 10">{{
            $t('Add Hotspot')
          }}</el-button>
        </div> -->
      </div>

      <el-table
        v-if="hotspots.length > 0"
        :data="hotspots"
        ref="hotspotTable"
        stripe
        :header-cell-style="{ background: '#fff' }"
        class="hotspot-table"
      >
        <el-table-column width="200" :label="$t('Hotspot position')" align="center">
          <template slot-scope="scope"> {{ $t('Hotspot') }} {{ scope.$index + 1 }} </template>
        </el-table-column>
        <el-table-column :label="$t('Combine products')" align="center">
          <template slot-scope="scope">
            <div class="product-info" @click="handleCurrentChange(scope.row)">
              <img :src="scope.row.productInfo.iconUrl.split(',')[0]" />
              <div class="description">{{ scope.row.productInfo.productName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Action')" width="350" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="reCombine(scope.row)">{{ $t('Update combined product') }}</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="text" @click="delHotspot(scope.row.uuid)">{{ $t('Delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="text-center submit-buttons">
      <el-button size="mini" @click="goPrevious">{{ $t('Previous Step') }}</el-button>
      <el-button size="mini" type="primary" @click="goNext" v-loading="submitLoading" :disabled="isNextDisable">{{ $route.params.step === 'step1'? $t('Next Step'): $t('Save') }}</el-button>
    </div>

    <!-- 关联展品 弹窗 -->
    <winDialog
      :dialogShow.sync="showCombination"
      :title="$t('Combine products')"
      :subTitle="$t('Combine products description')"
      :sure="combineProduct"
      :cancel="resetKeyword"
    >
      <template v-slot:bodyContent>
        <el-form :inline="true" class="product-search-form">
          <el-form-item>
            <el-input
              v-model="searchKeyword"
              size="mini"
              class="input__product-name"
              :placeholder="$t('Please enter product name for searching')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="search">{{ $t('homes.searchPlaceHolder') }}</el-button>
          </el-form-item>
        </el-form>
        <div class="product-table-wraper">
          <el-table
            :data="productList"
            ref="productTable"
            :show-header="false"
            stripe
            @current-change="handleCurrentChange"
            :header-cell-style="{ background: '#FAFAFA' }"
            class="product-table"
          >
            <el-table-column width="35">
              <template slot-scope="scope">
                <el-radio v-model="productId" :label="scope.row.productId" class="label__productId"></el-radio>
              </template>
            </el-table-column>
            <el-table-column width="460">
              <template slot-scope="scope">
                <div class="product-info" @click="handleCurrentChange(scope.row)">
                  <img :src="scope.row.iconUrl.split(',')[0]" />
                  <div class="description">{{ scope.row.productName }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          background
          :hide-on-single-page="true"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="goPage"
        >
        </el-pagination>
        <div class="current-product">
          <span class="_select">{{ $t('You selected') }}</span>
          <el-divider direction="vertical"></el-divider>
          <template v-if="currentProduct.productName">
            <span class="_name">{{ currentProduct.productName }} </span>
          </template>
        </div>
      </template>
    </winDialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Draggable } from 'draggable-vue-directive'
import DashUploadMore from '@/components/DashUploadMore'
import winDialog from '@/components/dialog/dialog'
import { getProducts, createHotspotImage, updateHotspotImage, setHotspots, getHotspotDetail } from '@/api'
export default {
  data: () => ({
    submitLoading: false,
    isDisabled: true,
    previewImageUrl: [],
    hotspots: [],
    draggableOption: {},
    box: null,
    currentHotspot: null,
    _initialPosition: {},

    showCombination: false,
    searchKeyword: '',
    productList: [],
    pagination: {
      pageSize: 4,
      total: 0,
      currentPage: 1
    },
    currentProduct: {},
    productId: '',
    hotspotDetail: {} // get from api
  }),
  computed: {
    ...mapGetters(['language']),
    isNextDisable() {
      const step = this.$route.params.step
      let bool = false
      if (step === 'step1') {
        bool = this.previewImageUrl.length === 0
      }
      if (step === 'step2') {
        bool = this.hotspots.length === 0
      }
      return bool
    },
    activeStep() {
      const step = this.$route.params.step
      let index = 0
      if (step === 'step1') {
        index = 0
      }
      if (step === 'step2') {
        index = 1
      }
      return index
    }
  },

  directives: {
    Draggable
  },

  components: {
    DashUploadMore,
    winDialog
  },

  mounted() {
    this.draggableOption = {
      boundingElement: this.$refs['hotspot-scene'],
      onDragStart: this.onDragStart,
      onDragEnd: this.onDragEnd,
      initialPosition: { left: 490, top: 270 }
    }
    this.getList()

    const hotImageId = this.$route.params.id
    const step = this.$route.params.step

    if (hotImageId) {
      getHotspotDetail({ id: hotImageId }).then(res => {
        this.hotspotDetail = res.data.data
        if (step === 'step1') {
          this.previewImageUrl.push(this.hotspotDetail.url)
        }

        // render hotspots array from api
        if (step === 'step2') {
          this.hotspots = []
          this.hotspotDetail.hotImagePointList.forEach(item => {
            this.hotspots.push({
              uuid: this.uuidv4(),
              draggableOption: {
                boundingElement: this.$refs['hotspot-scene'],
                onDragStart: this.onDragStart,
                onDragEnd: this.onDragEnd,
                initialPosition: {
                  left: item.cdnX,
                  top: item.cdnY
                }
              },
              productId: item.productId,
              productInfo: {
                iconUrl: item.productImgUrl,
                productName: item.productName
              },
              cdnX: item.cdnX,
              cdnY: item.cdnY
            })
          })
        }
      })
    }
  },

  methods: {
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },

    getList() {
      let pageInfo = {
        pageRows: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
        searchKeywords: this.searchKeyword,
        showType: 'PRODUCT_LIST',
      }
      const loading = this.$loading()
      getProducts(pageInfo)
        .then(res => {
          this.pagination.total = res.data.data.total
          this.pagination.currentPage = res.data.data.pageNum
          this.productList = res.data.data.list
        })
        .finally(() => {
          loading.close()
        })
    },
    search() {
      this.pagination.currentPage = 1
      this.getList()
    },
    goPage(val) {
      this.pagination.currentPage = val
      this.getList()
    },

    goNext() {
      const step = this.$route.params.step
      if (step === 'step1') {
        this.saveHotspotImage()
      }
      if (step === 'step2') {
        this.saveHotspots()
      }
    },

    saveHotspotImage() {
      const id = this.$route.params.id
      if (!id) {
        const loading = this.$loading()
        createHotspotImage({
          url: this.previewImageUrl[0]
        }).then(res => {
          const hotImageId = res.data.data
          this.$router.push('/hotspot-detail/step2/' + hotImageId)
        }).finally(()=> {
          loading.close()
        })
      }

      if (id) {
        if (this.hotspotDetail.url === this.previewImageUrl[0]) {
          this.$router.push('/hotspot-detail/step2/' + id)
        } else {
          const loading = this.$loading()
          updateHotspotImage({
            id,
            url: this.previewImageUrl[0]
          }).then(() => {
            this.$router.push('/hotspot-detail/step2/' + id)
          }).finally(() => {
            loading.close()
          })
        }
      }
    },

    saveHotspots() {
      const hotImageId = this.$route.params.id
      let params = []
      this.hotspots.forEach((item, index) => {
        params.push({
          languageType: this.language,
          hotImageId,
          pointIndex: index + 1,
          cdnX: item.cdnX,
          cdnY: item.cdnY,
          productId: item.productId
        })
      })
      const loading = this.$loading()
      setHotspots(params).then(() => {
        loading.close()
        this.$router.push('/hotspot')
      })
    },

    goPrevious() {
      const step = this.$route.params.step
      const id = this.$route.params.id
      if (step === 'step1') {
        this.$router.push('/hotspot')
      }
      if (step === 'step2') {
        this.$router.push('/hotspot-detail/step1/' + id)
      }
    },

    uploadFile() {
      this.$refs['scene-upload'].uploadAdd()
    },

    onDragStart(positionDiff, absolutePosition, event) {
      let box = event && event.target && event.target.closest('[draggable-state]')
      this.box = box
      if (box) {
        // Get the model
        const id = box.id
        let found = this.hotspots.find(b => b.uuid === id)

        if (found && !found.firstTouched) {
          // On the first touch, the directive's initialPosition, startDragPosition, currentDragPosition needs to be set wrt to the viewport
          const container = this.$refs['hotspot-scene'].getBoundingClientRect()
          const top = absolutePosition.top + container.top
          const left = absolutePosition.left + container.left
          box.style.top = top + 'px'
          box.style.left = left + 'px'

          let draggableState = JSON.parse(box.getAttribute('draggable-state')) || {}
          draggableState.initialPosition = { left, top }
          draggableState.startDragPosition = { left, top }
          draggableState.currentDragPosition = { left, top }
          box.setAttribute('draggable-state', JSON.stringify(draggableState))

          // Record in model that the box has been touched
          found.firstTouched = true
        } else {
          box.style.top = absolutePosition.top + 'px'
          box.style.left = absolutePosition.left + 'px'
        }
        // Remove the class
        box.classList.remove('drag-box')
      }
    },

    onDragEnd(positionDiff, absolutePosition) {
      // let box = event && event.target && event.target.closest('[draggable-state]')
      let box = this.box
      if (box) {
        const container = this.$refs['hotspot-scene'].getBoundingClientRect()
        const top = absolutePosition.top - container.top
        const left = absolutePosition.left - container.left
        box.style.top = top + 'px'
        box.style.left = left + 'px'

        // Add the class again
        box.classList.add('drag-box')

        // update hotspot coordinate
        this.hotspots = this.hotspots.map(item => {
          if (item.uuid === this.box.id) {
            item.cdnX = parseInt(Math.round(left))
            item.cdnY = parseInt(Math.round(top))
          }
          return item
        })
      }
    },

    addHotspot(event) {
      if (this.hotspots.length >= 10) {
        this.$notify({
          message: this.$t('You can only add the hotspot up to 10'),
          type: 'warning'
        })
        return
      }

      let sPos = this.$refs['hotspot-scene'].getBoundingClientRect()
      this._initialPosition = { left: event.clientX - sPos.x - 17, top: event.clientY - sPos.y - 17 }

      this.showCombination = true
    },

    delHotspot(uuid) {
      this.hotspots = this.hotspots.filter(item => item.uuid !== uuid)
    },

    reCombine(hotspot) {
      this.currentHotspot = hotspot
      this.showCombination = true
    },

    combineProduct(cb) {
      if (!this.productId) {
        this.$notify.warning(this.$t('Please select a product'))
        return
      }

      // update combined product
      if (this.currentHotspot && this.currentHotspot.uuid) {
        this.hotspots = this.hotspots.map(item => {
          if (item.uuid === this.currentHotspot.uuid) {
            item.productId = this.currentProduct.productId
            item.productInfo = this.currentProduct
          }
          return item
        })
      }

      if (this.currentHotspot === null) {
        this.hotspots.push({
          uuid: this.uuidv4(),
          draggableOption: Object.assign(this.draggableOption, {
            initialPosition: this._initialPosition
          }),
          productId: this.currentProduct.productId,
          productInfo: this.currentProduct,
          cdnX: parseInt(Math.round(this._initialPosition.left)),
          cdnY: parseInt(Math.round(this._initialPosition.top))
        })
      }

      this.currentProduct = {}
      this.currentHotspot = null
      this.productId = ''
      this.searchKeyword = ''
      cb()
    },

    resetKeyword(cb) {
      this.searchKeyword = ''
      cb()
    },

    handleCurrentChange(val) {
      if (val) {
        this.currentProduct = val
        this.productId = val.productId
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.drag-box
  position absolute !important

.hotspot-detail
  .steps-container
    width 650px
    margin 10px auto
  >>> .el-steps--simple
    background transparent
  >>> .is-process .el-step__icon.is-text
    border-radius 50%
    border none
    color $color-white
    background $color-main
  >>> .el-step.is-simple .el-step__icon
    width 24px
    height 24px
    font-size 13px
    line-height 1.5px
  >>> .el-step__head.is-success
    color $color-main
    border-color $color-main
  >>> .el-step__title.is-success
    color $color-black-65
  >>> .el-step.is-simple .el-step__arrow::before,
  >>> .el-step.is-simple .el-step__arrow::after
    content ''
    display inline-block
    position absolute
    height 2px
    width 115px
    background #C0C4CC
    transform none
  .op-section
    padding 24px
    background $color-gray-fb
    width 100%
    margin-bottom 16px
    p
      font-size 16px
      font-family PingFangSC-Medium, PingFang SC
      font-weight 500
      color $color-black-65
      margin-bottom 24px
    .txt-notice
      display flex
      color $color-main
      font-size 12px
      line-height 1.5
      margin-bottom 24px
      i
        color $color-orange-23
  .scene-container
    margin 10px auto
  .submit-buttons
    margin 10px auto

  .icondiv
    width 1000px
  .tips-image
    width 968px
    height 540px

  .hotspot-scene
    position relative
    width 1000px
    height 560px
    overflow hidden
    .scene-image
      width 100%
      height 100%
      object-fit cover
  .button-wrap
    width 1000px
    padding 16px 0

.hotspot
  position absolute
  cursor pointer
  width 34px
  height 34px
  left 490px
  top 270px
  .close
    width 13px
    height 13px
    position absolute
    top -4px
    right -3px
    color $color-white
    background $color-main
    line-height 13px
    font-size xx-small
    border-radius 50%
    text-align center
  .shadow
    position absolute
    width 34px
    height 34px
    background $color-white
    box-shadow 0 0 66px 6px $color-black
    border-radius 50%
    animation blink infinite 3s ease
  .hotspot-index
    position absolute
    left 6px
    top 6px
    width 22px
    height 22px
    color $color-main
    background $color-white
    border-radius 50%
    line-height 24px
    text-align center
    display block
    margin 0
    font-size 13px
    font-weight bold
    opacity 1
    box-shadow 0 0 66px 6px $color-black
.input__product-name
  width 255px
.product-search-form
  margin 0 auto
  padding-left 40px
.product-table-wraper
  max-height 370px
  overflow-y scroll
.product-table
  margin 0 auto
  margin-left 35px
  width 580px
  .label__productId .el-radio__label
    display none
  .el-table__row > td,
  &.el-table th
    border none
  &.el-table:before
    height 0px
.product-info
  display flex
  align-items flex-start
  justify-content space-between
  img
    width 64px
    height 64px
  .description
    width 350px
    height 66px
    overflow hidden
>>> .el-pagination
  margin-top 20px
  text-align center
.current-product
  height 54px
  margin 24px auto 0
  padding-left 40px
  background $color-white
  display flex
  align-items center
  width 558px
  ._select
    color $color-gray-fc1
    font-size 14px
  ._name
    width 400px
    font-size 14px
    color $color-gray-fc1
    font-weight bold

.hotspot-table
  width 1000px
  margin 20px auto 20px 0
  .product-info
    width 400px
    background $color-white
    padding 10px
    margin 0 auto
    .description
      width 300px
      text-align left
@keyframes blink
  0%, 100%
    opacity 0
  50%
    opacity 0.8
</style>
